// FNSKU（fnsku_code）の取り扱いユーティリティ
//
// DB の amazon_items.fnsku_code は「<FNSKU>_<登録時刻>」形式で保持している。
// 同じ FNSKU の商品を何度も登録する運用のため、登録時刻をサフィックスとして付与し
// 登録1件ごとに一意な値になるようにしている。
//
// ルール:
//   - 画面表示・バーコード・スキャン照合には必ず素の FNSKU を使う（サフィックスは出さない）
//   - 更新リクエストにはサフィックス付きの原文を送る（DB の一意性を壊さない）

/** サフィックスを除いた素の FNSKU を返す。画面表示・バーコード・照合用。 */
export const toDisplayFnsku = (fnskuCode?: string | null): string =>
  (fnskuCode ?? "").split("_")[0];

/**
 * 画面で編集された素の FNSKU に、元の fnsku_code のサフィックスを引き継ぐ。
 * 元の値にサフィックスが無い場合はそのまま返す（サーバ側で付与される）。
 */
export const withFnskuSuffixOf = (
  baseFnsku: string,
  originalFnskuCode?: string | null
): string => {
  const original = originalFnskuCode ?? "";
  const index = original.indexOf("_");
  return index >= 0 ? `${baseFnsku}${original.slice(index)}` : baseFnsku;
};
